jQuery(document).ready(function($) {

	console.log('Main JS file loaded');

	// Register Service Worker
	// if ('serviceWorker' in navigator) {
	//    navigator.serviceWorker.register("/serviceworker.js");
	// }
	
	$('#navclick').click(function(){
		$(this).toggleClass('toggled');
		$('#navContent').toggleClass('open')
	});

	var menuHeight = $(".top-matter").height();
	$(".first-content").css("padding-top", menuHeight);
	$( window ).resize(function() {
	    var menuHeight = $(".top-matter").height();
	    $(".first-content").css("padding-top", menuHeight);
	});

});